import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@mui/material';
import { IoClose } from "react-icons/io5";
import Grid from "@mui/material/Grid";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { AiOutlineInfoCircle } from "react-icons/ai";
import axios from "axios";
import { styled } from '@mui/material/styles';
import '../../SelfServe/SelfServe.css';
import Switch from '@mui/material/Switch';
import CreatePriceStr from '../../common/common/CreatePriceStr'
import { useApp } from '../../../context/AppContext';

const paths = require('../../../paths.json');

const AntSwitch = styled(Switch)(({ theme }) => ({
   width: 42,
   height: 24,
   marginLeft: 5,
   padding: 0,
   display: 'flex',
   '&:active': {
      '& .MuiSwitch-thumb': {
         width: 24,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
         transform: 'translateX(9px)',
      },
   },
   '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
         transform: 'translateX(17px)',
         color: '#fff !important',
         '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: 'var(--brand-color)',
         },
      },
   },
   '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 20,
      height: 20,
      borderRadius: 40,
      transition: theme.transitions.create(['width'], {
         duration: 200,
      }),
   },
   '& .MuiSwitch-track': {
      borderRadius: 100,
      opacity: 1,
      backgroundColor:
         theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
   },
}));

const minimum_message_length = 10000

const minimum_values = {
   GBP: 100,
   USD: 100,
   EUR: 100,
   SEK: 1000,
   AUD: 150,
   CAD: 150,
}

const example_values = {
   GBP: [500, 1000],
   USD: [750, 1500],
   EUR: [750, 1500],
   SEK: [65, 130],
   AUD: [1000, 2000],
   CAD: [1000, 2000],
}

const SetupPaidDMs = (props) => {
   const { t } = useTranslation();
   const { snackConfig, setSnackConfig } = useApp();
   const [lengthOfMessageErr, setLengthOfMessageErr] = useState('')

   // Set paidDMsActiveSettings to true by default if addProduct is true
   React.useEffect(() => {
      if (props.addProduct) {
         props.setPaidDMsActiveSettings(true);
      }
   }, [props.addProduct]);

   return (
      <Modal open={props.paidDMsModal} onClose={() => props.setPaidDMsModal(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
         <Grid container justifyContent='center'
            sx={{ minHeight: '100vh', display: 'flex', maxWidth: '600px', margin: 'auto', maxHeight: '600px', outline: 'none' }}>
            <Grid container
               sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  // minHeight: props.windowWidth > 1200? '500px': '100%',
                  // display:'flex',
                  outline: 'none',
                  maxWidth: '600px',
                  width: '100vw',
                  minWidth: '320px',
                  maxHeight: props.windowWidth > 600 ? 'calc(100vh - 20px)' : '100vh',
                  marginTop: props.windowWidth > 600 ? '10px' : '0px',
                  paddingBottom: props.windowWidth > 600 ? '20px' : '100px',
                  height: 'auto',
                  borderRadius: props.windowWidth > 600 ? '10px' : '0px',
                  position: 'relative',
                  margin: '0px', boxShadow: props.windowWidth >= 1200 ? '0 5px 25px 0 rgba(35, 40, 105, 0.04)' : '',
                  paddingTop: '50px',
                  overflow: props.windowWidth > 900 ? '' : 'auto', overflowX: 'hidden',
               }}>

               <div style={{ backgroundColor: '#ffffff', width: '100%', borderRadius: props.windowWidth > 600 ? '10px' : '0px', paddingBottom: props.windowWidth < 600 ? '100px' : '0px', }}>


                  <Grid container
                     style={{
                        width: props.windowWidth > 1200 ? "90%" : '90%',
                        justifyContent: "center",
                        alignItems: "center",
                        height: 'auto',
                        margin: '20px auto 10px auto',
                        maxHeight: "2000px",
                        display: "flex",
                     }}>
                     <Grid lg={11} xs={11}>
                        {/* add condtional for setup or edit depending on if it already exists */}

                        <h3>{props.addProduct ? t('dashboard.paidDms.addCustomProduct') : t('dashboard.paidDms.editCustomProduct')}</h3>
                     </Grid>
                     <Grid lg={1} xs={1}
                        style={{
                           top: '0px',
                           padding: '0px',
                           float: 'right',
                           textAlign: 'right',
                        }}
                     >
                        <div style={{ '&:hover': { cursor: 'pointer' } }}>
                           <a onClick={() => {
                              //    setNewTierModal(false);
                              props.setPaidDMsModal(false);


                           }}>
                              <IoClose className={'modal-close-icon'} style={{ width: '25px', height: '25px' }} />
                           </a>
                        </div>

                     </Grid>



                  </Grid>



                  <div style={{
                     backgroundColor: '#D3DCE7',
                     marginTop: '0px',
                     width: '90%',
                     height: '1px',
                     marginBottom: '10px',
                     margin: '10px auto 20px auto',
                     padding: '0px 0px'
                  }} />


                  <Grid container sx={{ width: '90%', margin: 'auto' }} justifyContent={'space-between'}>

                     <Grid
                        justifyContent={'space-between'}
                        container
                        xs={12}
                        sx={{ margin: '10px 0px 10px 0px' }}
                     >


                        <Grid container justifyContent={'space-between'}>

                           <Grid md={12} xs={12} sx={{ paddingBottom: '20px' }}>

                              <Grid
                                 xs={12}
                                 md={12}
                                 lg={12}
                                 sx={{ display: 'flex', width: '100%' }}
                              >
                                 <span style={{
                                    color: '#222222',
                                    fontWeight: '700',
                                    fontSize: '14px'
                                 }}>{t('dashboard.paidDms.priceOneMessage')}</span>

                              </Grid>


                              <form style={{
                                 backgroundColor: '#ffffff',
                                 color: '#fff',
                                 borderRadius: '5px',
                                 padding: '0px 15px',
                                 display: 'flex',
                                 height: '46px',
                                 margin: '10px 0px 5px 0px',
                                 border: '1px solid #C7D1DE',
                                 width: '100%',
                                 maxWidth: '800px',
                                 zIndex: '10',
                                 boxSizing: 'border-box'
                              }}>
                                 <input type={"text"} id={"emailCaptureInput"} style={{
                                    border: 'none', width: props.windowWidth > 560 ? '85%' : '72%', fontWeight: '500', color: '#1D1D1D', fontSize: '16px',
                                    fontFamily: 'Roboto'
                                 }}
                                    placeholder={t('dashboard.paidDms.minimumPricePlaceholder')}
                                    value={props.paidDMsMinimumPriceStr !== '0' ? props.currencySymbol + props.paidDMsMinimumPriceStr + props.currencySymbolPost : ''}
                                    onChange={(event) => {
                                       let new_value = event.target.value.replace(/[^0-9.]/g, '')
                                       props.setPaidDMsMinimumPriceStr(
                                          new_value.replace('£', '')
                                             .replace('$', '')
                                             .replace('€', '')
                                             .replace('AU$', '')
                                             .replace('CA$', '')
                                             .replace(' kr', '')
                                       )
                                       let new_value_value = new_value
                                       if (!new_value_value.includes('.')) {
                                          new_value_value = new_value_value + '.00'
                                       } else if (new_value_value[new_value_value.length - 2] === '.') {
                                          new_value_value = new_value_value + '0'
                                       } else if (new_value_value[new_value_value.length - 1] === '.') {
                                          new_value_value = new_value_value + '00'
                                       }
                                       new_value_value = new_value_value.replace('.', '')
                                          .replace(',', '')
                                          .replace('£', '')
                                          .replace('$', '')
                                          .replace('€', '')
                                          .replace('AU$', '')
                                          .replace('CA$', '')
                                          .replace(' kr', '')
                                       props.setPaidDMsMinimumPrice(
                                          new_value_value
                                       )
                                       if (Number(new_value_value) < minimum_values[props.currency]) {
                                          props.setPriceOfDMsError(t('onboarding.yourOfferingModal.minimumPriceError', { amount: CreatePriceStr(minimum_values[props.currency], props.currency, true) }));
                                       } else {
                                          props.setPriceOfDMsError('');
                                       }
                                    }}
                                 />
                                 <span style={{ fontWeight: '500', margin: 'auto', fontSize: '12px', color: "grey", minWidth: '100px', textAlign: 'end' }}>{t('dashboard.paidDms.minimumSuffix', { amount: CreatePriceStr(minimum_values[props.currency], props.currency, true) })}</span>

                              </form>
                              {
                                 props.priceOfDMsError ?
                                    <div style={{ width: '100%', }}>
                                       <span style={{
                                          display: 'block',
                                          color: 'var(--danger-color)',
                                          fontWeight: '600',
                                          fontSize: '12px',
                                          textAlign: 'center',
                                          paddingTop: '8px',
                                          width: '100%',
                                          margin: props.windowWidth > 900 ? '0px auto ' : '10px auto 0px',
                                       }}>
                                          {props.priceOfDMsError}
                                       </span>
                                    </div>
                                    : ''
                              }
                           </Grid>


                           <Grid md={12} xs={12}>

                              <Grid
                                 xs={12}
                                 md={12}
                                 lg={12}
                                 sx={{ display: 'flex', width: '100%' }}
                              >
                                 <span style={{
                                    color: '#222222',
                                    fontWeight: '700',
                                    fontSize: '14px'
                                 }}>{t('dashboard.paidDms.setMaxMessageLength')}</span>

                              </Grid>


                              <form style={{
                                 backgroundColor: '#ffffff',
                                 color: '#fff',
                                 borderRadius: '5px',
                                 padding: '0px 15px',
                                 display: 'flex',
                                 height: '46px',
                                 margin: '10px 0px 5px 0px',
                                 border: '1px solid #C7D1DE',
                                 width: '100%',
                                 maxWidth: '800px',
                                 zIndex: '10',
                                 boxSizing: 'border-box'
                              }}>

                                 <input type={"number"} id={"emailCaptureInput"} style={{
                                    border: 'none', width: props.windowWidth > 560 ? '85%' : '72%', fontWeight: '500', color: '#1D1D1D', fontSize: '16px',
                                    fontFamily: 'Roboto',
                                 }}
                                    placeholder='1000'
                                    value={props.paidDMsMaximumMessageLength}
                                    onChange={(event) => {
                                       if (event.target.value < minimum_message_length) {
                                          setLengthOfMessageErr(t('dashboard.paidDms.minLengthError', { length: String(minimum_message_length - 1) }))
                                       } else {
                                          setLengthOfMessageErr('')
                                       }
                                       // props.setUpdatedMonthlyInput(true)
                                       props.setPaidDMsMaximumMessageLength(event.target.value)
                                    }}
                                 />
                                 <span style={{ fontWeight: '500', margin: 'auto', fontSize: '12px', color: "grey", minWidth: '100px', textAlign: 'end' }}>{t('dashboard.paidDms.charMinimum')}</span>

                              </form>
                              {
                                 lengthOfMessageErr ?
                                    <div style={{ width: '100%', }}>
                                       <span style={{
                                          display: 'block',
                                          color: 'var(--danger-color)',
                                          fontWeight: '600',
                                          fontSize: '12px',
                                          textAlign: 'center',
                                          paddingTop: '8px',
                                          width: '100%',
                                          margin: props.windowWidth > 900 ? '0px auto ' : '10px auto 0px',
                                       }}>
                                          {lengthOfMessageErr}
                                       </span>
                                    </div>
                                    : ''
                              }
                           </Grid>


                           <div>
                              <span
                                 style={{
                                    color: 'var(--danger-color)',
                                    fontWeight: '600',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    paddingTop: '4px',
                                    display: 'block'
                                 }}
                              >
                                 {props.monthlyPriceError}
                              </span>
                              <span style={{ color: '#6D89AF', paddingTop: '0px', marginTop: '0px', fontSize: '10px', display: 'block' }}>
                                 <AiOutlineInfoCircle style={{ color: 'black', paddingRight: '5px', position: 'relative', top: '1.5px' }} />
                                 {t('dashboard.paidDms.pricesPerformBest', { low: CreatePriceStr(example_values[props.currency][0], props.currency, true), high: CreatePriceStr(example_values[props.currency][1], props.currency, true) })}
                              </span>
                           </div>
                        </Grid>
                     </Grid>

                     {!props.addProduct && (
                        <Grid container md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                           <div style={{
                              backgroundColor: '#D3DCE7',
                              width: '100%',
                              height: '1px',
                              margin: '20px auto 25px auto',
                              padding: '0px 0px'
                           }} />

                           <Grid
                              container
                              xs={12}
                              sx={{ margin: '5px 0px 10px 0px' }}
                           >
                              <Grid xs={7} md={6} lg={6} sx={{ display: 'flex', width: '100%' }}>
                                 <span style={{
                                    color: '#222222',
                                    fontWeight: '700',
                                    fontSize: '14px'
                                 }}>{t('dashboard.paidDms.offerMessages')}</span>
                              </Grid>

                              <Grid
                                 xs={0}
                                 md={0}
                                 lg={0}
                                 sx={{
                                    paddingTop: { xs: '5px', md: '0px' },
                                    paddingLeft: { xs: '0px' },
                                 }}
                              >
                              </Grid>
                              <Grid
                                 xs={5}
                                 md={6}
                                 lg={6}
                                 sx={{
                                    paddingTop: { md: '0px' }, display: 'flex'
                                 }}
                              >

                                 <FormGroup sx={{ margin: 'auto 0px auto auto' }}>
                                    <FormControlLabel control={
                                       <AntSwitch
                                          checked={props.paidDMsActiveSettings} onChange={
                                             (event) => {
                                                props.setPaidDMsActiveSettings(event.target.checked);
                                             }}
                                       />}
                                       labelPlacement="start"
                                       label={
                                          <span style={{
                                             fontSize: '14px',
                                             margin: '0px 5px 0px 0px',
                                             color: '#222222',
                                             fontWeight: '400',
                                             fontStyle: 'var(--main-font-family)',
                                          }}>
                                             {!props.paidDMsActiveSettings ? t('dashboard.paidDms.notActive') : t('dashboard.paidDms.active')}
                                          </span>}
                                    />
                                 </FormGroup>
                              </Grid>
                              <div>
                                 <span style={{ color: '#6D89AF', paddingTop: '0px', marginTop: '5px', fontSize: '10px', display: 'block', lineHeight: '12px' }}>
                                    <AiOutlineInfoCircle style={{ color: 'black', paddingRight: '5px', position: 'relative', top: '1.5px' }} />
                                    {
                                       props.paidDMsActive === false ? t('dashboard.paidDms.tierVisible') :
                                          t('dashboard.paidDms.tierHidden')
                                    }
                                 </span>
                              </div>
                           </Grid>

                           <div style={{
                              backgroundColor: '#D3DCE7',
                              width: '100%',
                              height: '1px',
                              margin: '20px auto 25px auto',
                              padding: '0px 0px'
                           }} />
                        </Grid>
                     )}

                     <Grid container sx={{ width: '100%', display: 'flex', paddingBottom: '30px', margin: 'auto' }}>
                        <Grid xs={6} sx={{ margin: 'auto auto auto auto' }}>
                        </Grid>

                        <Grid xs={6} sx={{ display: 'flex', width: '100%' }}>
                           <Button variant="contained" disableElevation
                              sx={{
                                 padding: '8px 20px',
                                 width: 'auto',
                                 marginRight: '0px',
                                 marginLeft: 'auto',
                                 textAlign: 'center',
                                 display: 'inline-block',
                                 borderRadius: '10px',
                                 textTransform: 'none',
                                 border: '2px var(--brand-color) solid',
                                 backgroundColor: 'var(--brand-color)',
                                 '&:hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    border: '2px var(--brand-color-hover) solid',
                                 }
                              }}
                              disabled={props.priceOfDMsError || lengthOfMessageErr}
                              onClick={() => {
                                 const form_data = new FormData();
                                 form_data.append('currency', props.currency)
                                 form_data.append('new_price', props.paidDMsMinimumPrice)
                                 form_data.append('active', props.paidDMsActiveSettings)
                                 form_data.append('maximum_message_length', props.paidDMsMaximumMessageLength)
                                 axios({
                                    method: 'post',
                                    url: paths.BACKEND_URL + 'api/influencer/update_dm_settings',
                                    data: form_data,
                                    headers: {
                                       'Content-type': 'application/json',
                                    },
                                    withCredentials: true
                                 }).then(
                                    res => {
                                       if (!res.data.error) {
                                          props.setPaidDMsModal(false);
                                          props.setMaxMessageLength(props.paidDMsMaximumMessageLength);
                                          props.setState({ paidDMs_show: props.paidDMsActiveSettings, updatedPerks: res.data.updated_tier_perks })

                                          setSnackConfig({
                                             open: true,
                                             message: props.paidDMsActiveSettings ? (props.addProduct ? t('dashboard.paidDms.paidMessagesAdded'): t('dashboard.paidDms.paidMessagesUpdated')) : t('dashboard.paidDms.paidMessagesRemoved'),
                                          })
                                          if (props.paidDMsActiveSettings){
                                             props.handleTabNavigation('platform')
                                             props.navigate('?page=messages')
                                          } else {
                                             props.handleTabNavigation('platform')
                                          }
                                       }
                                    }
                                 )
                              }}
                           >
                              <span className="fa fa-search"
                                 style={{ fontWeight: '600', fontSize: '15px' }}>
                                 {props.addProduct ? t('dashboard.paidDms.activateMessages') : t('dashboard.paidDms.submit')}
                              </span>
                           </Button>
                        </Grid>
                     </Grid>
                  </Grid>
               </div>
            </Grid>

            {/*<SnackbarAlert*/}
            {/*   msg={this.state.error_msg}*/}
            {/*   severity={"error"}*/}
            {/*   snackbarBackgroundColor={'var(--danger-color)'}*/}
            {/*   open={this.state.show_error}*/}
            {/*   handleClose={() => {*/}
            {/*      this.setState({*/}
            {/*         show_error: false,*/}
            {/*         error_msg: ''*/}
            {/*      })*/}
            {/*   }}*/}
            {/*/>*/}


            {/*<SnackbarAlert*/}
            {/*   msg={'Tier link copied'}*/}
            {/*   severity={"success"}*/}
            {/*   backgroundColor={'#3B55F3'}*/}
            {/*   open={this.state.show_snack}*/}
            {/*   handleClose={() => {*/}
            {/*      this.setState({*/}
            {/*         show_snack: false*/}
            {/*      })*/}
            {/*   }}*/}
            {/*/>*/}


         </Grid>
      </Modal>
   );
};

export default SetupPaidDMs;
